<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <form class="form-horizontal sp-0" name="formSelectPortalUser" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttLabel="portal_user_search" ttFocus [(ttModel)]="portalUserSearch" (ttOnBlur)="onBlur('portalUserSearch')" (ttModelChange)="onChanged($event, 'portalUserSearch')" ttShowClearButton [ttButtons]="portalUserSearchButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListPortalUsers" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)"></tt-list>
</tt-page>
